import moment from 'moment';
import { mapActions, mapGetters, mapState } from 'vuex';
import insightPanel from '@/components/insight/insight-panel/insight-panel.vue';
import insightLink from '@/components/insight/insight-link/insight-link.vue';

export default {
  components: {
    insightPanel,
    insightLink,
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    ...mapState('insight', ['analysis']),
    allArticlesAway() {
      return !this.isLayoutMobile;
    },
    allArticlesLink() {
      if (!this.isLayoutMobile) {
        return 'https://analysis.predictit.org/';
      }
      return {
        path: `/insight/${btoa(encodeURI('//analysis.predictit.org/'))}`,
      };
    },
  },
  methods: {
    ...mapActions('insight', ['getAnalysis']),
    createLink(url) {
      return {
        path: `/insight/${btoa(encodeURI(url))}`,
      };
    },
    createDate(date) {
      if (date) {
        const dt = moment(date.split(' ')[0]);
        const diff = moment().diff(dt, 'days');
        const map = {
          0: 'Today',
          1: 'Yesterday',
          2: dt.format('dddd'),
          3: dt.format('dddd'),
          4: dt.format('dddd'),
          5: dt.format('dddd'),
          6: dt.format('dddd'),
        };
        return map[diff] || dt.format('MMM. D');
      }
      return '';
    },
  },
  mounted() {
    this.getAnalysis({});
  },
};



// WEBPACK FOOTER //
// ./src/components/insight/insight-news/insight-news.js